import CashbackCell from './CashbackCell';

export default CashbackCell;
